import { defineMessages } from 'react-intl'

import { FARE_TYPE } from './constants'

export const fareTypeMessages = defineMessages({
  [FARE_TYPE.NORMAL]: {
    id: 'fareType.normal',
    defaultMessage: 'Normal'
  },
  [FARE_TYPE.PROMO]: {
    id: 'fareType.promo',
    defaultMessage: 'Promo'
  }
})
